export const StickyBarModuleName = 'Sticky Bar';
